import { ValidationResult } from '../types';

/**
 * Validates a salary input
 */
export function validateSalary(value: number, smmlv: number): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  
  if (value <= 0) {
    errors.push('El salario debe ser mayor a cero');
  }
  
  if (value > 0 && value < smmlv) {
    warnings.push('El salario es menor al mínimo legal');
  }
  
  return {
    valid: errors.length === 0,
    errors,
    warnings,
  };
}

/**
 * Validates exchange rate input
 */
export function validateExchangeRate(value: number): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  
  if (value <= 0) {
    errors.push('La tasa de cambio debe ser mayor a cero');
  }
  
  if (value > 0 && (value < 1000 || value > 10000)) {
    warnings.push('La tasa de cambio parece inusual');
  }
  
  return {
    valid: errors.length === 0,
    errors,
    warnings,
  };
}

/**
 * Validates SMMLV input
 */
export function validateSMMLV(value: number): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  
  if (value <= 0) {
    errors.push('El salario mínimo debe ser mayor a cero');
  }
  
  return {
    valid: errors.length === 0,
    errors,
    warnings,
  };
}

/**
 * Validates a generic numeric input
 */
export function validateNumericInput(value: string): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  
  // Try to parse the value
  const cleaned = value.replace(/[^\d.,]/g, '');
  const parsed = parseFloat(cleaned.replace(/,/g, '.'));
  
  if (isNaN(parsed)) {
    errors.push('El valor debe ser numérico');
  }
  
  return {
    valid: errors.length === 0,
    errors,
    warnings,
  };
}

/**
 * Validates that a required field is not empty
 */
export function validateRequired(value: string | number): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  
  if (value === '' || value === null || value === undefined) {
    errors.push('Este campo es requerido');
  }
  
  return {
    valid: errors.length === 0,
    errors,
    warnings,
  };
}
